import React, {useState, useEffect} from 'react';
import {useDispatch} from 'react-redux';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {labels} from '../../../util/uiconstants';
import Loader from '../../Common/Loaders/loadingindicator';
import styled from 'styled-components';
import EllipsesControl from '../../Common/EllipsesControl/EllipsesControl';
import Toast from '../../Common/Toast/Toast';
import {clearErrors} from '../../../actions/erroractions';
import {setIsModalOpen} from '../../../actions/modalstateactions';
import TicketField from '../common/ticketfield';

const DeleteMessageWrapper = styled.section`
	.delete-message-loader {
		padding: var(--px-24) !important;
	}

	.wrapper {
		//ticketstart
		.ticketdetail {
			padding-bottom: var(--spacing-x-large);
			.description {
				padding-bottom: var(--spacing-small);
			}

			.motif-form-field {
				width: var(--px-400);
				.motif-input {
					height: var(--px-44);
				}
			}
		}
		//ticketend
		.messagelabel {
			padding-bottom: var(--spacing-x-large);
			border-bottom: var(--px-1) solid var(--neutrals-200);
		}
		.messagetitle {
			padding: var(--spacing-x-large) 0;
			.ellipses {
				display: inline-flex;
			}
		}
	}

	.modal-footer {
		width: 100%;
		display: flex;
		padding: var(--spacing-x-large);
		justify-content: end;
		button {
			margin-left: var(--px-12);
		}
	}
	.deletewwrapper {
		padding: var(--spacing-x-large);
		padding-bottom: 0;
	}
`;

function DeleteMessage(props) {
	const dispatch = useDispatch();

	const [ticketNumber, setTicketNumber] = useState('');
	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	useEffect(() => {
		clearError(true);
	}, []);

	function handlerOnTicketEntered(e) {
		setTicketNumber(e.target.value);
	}

	return (
		<DeleteMessageWrapper>
			{props.isLoading ? (
				<section className="delete-message-loader">
					<Loader show view="blockView" styleName="loadingstyle" />
				</section>
			) : (
				<section className="deletewwrapper customScrollbar">
					<section className="delete">
						<section
							className="toastMessage"
							style={{
								display:
									props.errorMessage && props.errorMessage.length > 0
										? 'block'
										: 'none'
							}}
						>
							<Toast variant="error" onClose={() => props.clearErrorMessage()}>
								{props.errorMessage}
							</Toast>
						</section>
						<section className="wrapper">
							<section
								className="messagelabel motif-body1-default-light"
								aria-label="message"
							>
								{labels.messagingModalDeleteMessage}
							</section>
							<section
								className="messagetitle motif-body1-default-regular"
								aria-label=""
							>
								<EllipsesControl
									content={props?.messageToDelete?.messageTitle}
									tooltip={props?.messageToDelete?.messageTitle}
									displayId={''}
									noOfLines={1}
									ellipsisClass=""
								/>
							</section>
							<section>
								<TicketField
									ticketNumber={ticketNumber}
									onTicketChanged={handlerOnTicketEntered}
								/>
							</section>
						</section>
					</section>
				</section>
			)}
			<section className="modal-footer">
				<MotifButton
					size="medium"
					variant="ghost"
					onClick={() => props.onCancelClick()}
				>
					{labels.messagingModalDeleteCancel}
				</MotifButton>
				<MotifButton
					size="medium"
					variant="primary"
					disabled={ticketNumber.trim().length == 0 ? true : false}
					onClick={() => props.onDeleteClick(ticketNumber)}
				>
					{labels.messagingModalDeleteButton}
				</MotifButton>
			</section>
		</DeleteMessageWrapper>
	);
}

export default DeleteMessage;
